type PrimaryFocusItem = {
  title: string
  slug: string
  primaryFocus: string
}

export type PrimaryFocusNode = {
  node: PrimaryFocusItem
}

export const mapTermsToPrimaryFocus = (terms: PrimaryFocusNode[]) => {
  if (!terms) return null

  return terms.reduce((acc, term) => {
    const { primaryFocus, title, slug } = term.node
    Object.assign(acc, { [title]: primaryFocus })
    Object.assign(acc, { [slug]: primaryFocus })
    return acc
  }, {})
}
